import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot,
    UrlTree
} from '@angular/router';
import { Observable, first, map, of } from 'rxjs';
import { LgvUserService } from '../core.module';

@Injectable({
    providedIn: 'root'
})
export class ShortUrlResolver implements Resolve<any> {
    constructor(private lgvUserService: LgvUserService,
        private router: Router) { }
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.lgvUserService.getLongUrl(route.params['shortCode']).pipe(map((response) => {
            return response.longUrl;
        }));
    }
}
